import { NextSeo } from "next-seo";
import { RegisterPage } from "~/modules/auth/pages/register";
import { Navbar } from "~/components/Navbar/component";
import { PageTrack } from "~/modules/analytics/components/PageTrack";
import { addBaseUrl } from "~/modules/app/seo/addBaseUrl";
import { Routes } from "~/routes";
import { UserFetcher } from "~/modules/user/components/UserFetcher";

// // // //

export default function Register() {
    return (
        <PageTrack route={Routes.register}>
            <NextSeo
                title="Create account"
                canonical={addBaseUrl(Routes.register)}
            />
            <UserFetcher>
                {({ user }) => <Navbar route={Routes.register} user={user} />}
            </UserFetcher>
            <RegisterPage />
        </PageTrack>
    );
}
